export type Language = 'en' | 'ar';

export enum HabitType {
  PRAYER = 'PRAYER',
  REGULAR = 'REGULAR',
  COUNTER = 'COUNTER',
}

export enum PrayerQuality {
  MISSED = 0,
  ON_TIME = 1,
  JAMAA = 2,
  TAKBIRAH = 3,
}

export enum LogStatus {
  DONE = 'DONE',
  SKIP = 'SKIP',
  FAIL = 'FAIL',
  EXCUSED = 'EXCUSED',
}

export interface Habit {
  id: string;
  name: string;
  nameAr: string; // Ensuring this exists
  type: HabitType;
  emoji?: string;
  icon?: string;
  color?: string; // Icon color (hex or CSS color)
  dailyTarget?: number;
  presetId?: string;
  isActive: boolean; // Ensuring this exists
  order: number;
  startDate?: string;
  isArchived?: boolean;
  requireReason?: boolean; // If true, ask for reason when habit is failed
  affectsScore?: boolean; // If false, habit is "Bonus" and doesn't affect global score/streaks (default: true)
  createdAt?: string;
  updatedAt?: string;
}

export interface HabitLog {
  id: string;
  habitId: string;
  date: string;
  value: number;
  status?: LogStatus;
  notes?: string;
  timestamp: number;
  reason?: string;
}

export interface UserPreferences {
  language: Language;
  gender: 'male' | 'female';
  isExcused: boolean;
  showHijri: boolean;
  showHadith: boolean;
  showAIInsights: boolean;
  dateOfBirth: string | null;
  theme?: 'dark' | 'light';
  notifications?: boolean;
  prayerReminders?: boolean;
  dailyGoalReminder?: boolean;
  reminderTime?: string;
  hijriDateDisplay?: boolean;
}

export const DEFAULT_PREFERENCES: UserPreferences = {
  language: 'ar',
  gender: 'male',
  isExcused: false,
  showHijri: true,
  showHadith: false,
  showAIInsights: false,
  dateOfBirth: '1991-11-11',
  theme: 'dark',
  notifications: true,
  prayerReminders: true,
  dailyGoalReminder: true,
  reminderTime: "08:00",
  hijriDateDisplay: true,
};

export interface User {
  id: string;
  email?: string;
  name?: string;
  isDemo?: boolean;
}

// Custom reason - matches Supabase custom_reasons table
export interface CustomReason {
  id: string;
  reason_text: string; // Column name in Supabase
  createdAt?: string;
}

// AI Daily Briefing - Generated once per day
export interface DailyBriefing {
  home_advice: string;
  analytics_insight: string;
  five_prayers_focus: string;
  rawatib_focus: string;
  timestamp: string;
}